import axios from "axios"
import { Notification } from "element-ui"
const FORMAT = {
	"it-IT": "dd/MM/yyyy",
	"es-ES": "dd/MM/yyyy",
	"en-GB": "dd/MM/yyyy",
	"en-US": "MM/dd/yyyy"
}

const MAP_CURRENCY = {
	EUR: "€"
}
export const CURRENCY = ["EUR"]
export async function isAuth() {
	try {
		return {
			auth: await axios.get(process.env.VUE_APP_API_URL + "/api/auth/testAuth", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			}),
			module: await axios.get(process.env.VUE_APP_API_URL + "/api/organizationmodule", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
		}
	} catch (err) {
		throw "connection error"
	}
}

export function goto(route) {
	// this.$router.replace(route).catch(err => {})
	this.$router.push(route).catch(err => {
		if (err.name !== "NavigationDuplicated") {
			return false
		}
	})
}

/**
 * @param {string} type success, warning, info, error
 * @param {string} title already translated
 * @param {string} message already translated
 * @param {int} duration msec, 0 if not closing automatically; default 5000msec
 * @param {string} position top-right (DEFAULT), top-left, bottom-right, bottom-left
 * @param {*} dangerouslyUseHTMLString true if message has html, false otherwise (DEFAULT)
 * @param {*} clickCallback cossa vuto che fassa, eh?
 */
export function notification(
	type,
	title,
	message,
	duration = 5000,
	position = "top-right",
	dangerouslyUseHTMLString = false,
	clickCallback = () => {}
) {
	function delayedNotify(context, type, title, message, duration, position, dangerouslyUseHTMLString, clickCallback) {
		Notification({
			title: title,
			message: message,
			duration: duration,
			type: type,
			position: position,
			dangerouslyUseHTMLString: dangerouslyUseHTMLString,
			onClick: clickCallback
		})
	}

	var context = this
	setTimeout(function () {
		delayedNotify(context, type, title, message, duration, position, dangerouslyUseHTMLString, clickCallback)
	}, 1)
}

var registered_errors = [
	"invalid-email",
	"invalid-user",
	"entity-protected-name",
	"anotherone-active",
	"code-already-exists",
	"reached-users-limit",
	"max-procedures-created",
	"expired-password"
]

export function processError(title, errors) {
	errors.forEach(message => {
		if (message.includes("users_email_key"))
			this.$notification("error", title, this.$t("user-email-uindex-error"), 0)
		else if (message.includes("users_username_key"))
			this.$notification("error", title, this.$t("username-uindex-error"), 0)
		else if (message.includes("subscriptions_name_key"))
			this.$notification("error", title, this.$t("subscriptions-name-key"), 0)
		else if (message.includes("areas_un")) this.$notification("error", title, this.$t("areas-un-key"), 0)
		else if (registered_errors.includes(message)) this.$notification("error", title, this.$t(message), 0)
		else this.$notification("error", title, "", 0)
	})
}

/**
 *
 * @param data
 * @param lang
 */
export function dateFormat(data, lang) {
	var day = data.getDay() > 10 ? data.getDay() : "0" + data.getDay()
	var month = data.getMonth() + 1 > 10 ? data.getMonth() + 1 : "0" + data.getMonth()
	return data.getFullYear() + "-" + month + "-" + day
}

export function formatDate(stringDate) {
	const date = new Date(stringDate)

	const day = date.getDate().toString().padStart(2, "0")
	const month = (date.getMonth() + 1).toString().padStart(2, "0")
	const year = date.getFullYear()

	return `${day}/${month}/${year}`
}

/**
 *
 * @param {*} array: array of users's permissions
 * @param {*} permissions: required permissions
 * @param {*} roles: array of users's roles
 * @returns
 */
export const SUPER_ROLE = ["administrator", "full-administrator"]
export function hasPermissionTo(array, permissions, roles) {
	for (let role of roles) {
		if (SUPER_ROLE.indexOf(role.name) > -1) return true
	}
	if (!Array.isArray(permissions)) permissions = [permissions]
	for (let permission of permissions) {
		for (let item of array) {
			if (item.name == permission) {
				return true
			}
		}
	}
	return false
}

export function modulePermission_formatter(array, permissions_array) {
	var permission = permissions_array ? permissions_array : {}
	array.forEach(modulepermission => {
		if (!permission[modulepermission.module.name]) permission[modulepermission.module.name] = []
		permission[modulepermission.module.name].push(modulepermission)
	})

	return permission
}

export function address_formatter(address) {
	var c
	if (address == "") c = {}
	else c = JSON.parse(address)
	return c
}

export function showResult(array, success, error, text) {
	var wait = 2000 * array.length
	setTimeout(() => {
		var item = {
			success: success,
			error: error,
			text: text
		}
		array.push(item)
		setTimeout(() => {
			array.splice(0, 1)
		}, 4000)
	}, wait)
}

export function getBrowser() {
	return (navigator.sayswho = (function () {
		var ua = navigator.userAgent,
			tem,
			M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
		if (/trident/i.test(M[1])) {
			tem = /\brv[ :]+(\d+)/g.exec(ua) || []
			return "IE " + (tem[1] || "")
		}
		if (M[1] === "Chrome") {
			tem = ua.match(/\b(OPR|Edge?)\/(\d+)/)
			if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera").replace("Edg ", "Edge ")
		}
		M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"]
		if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
		return M.join(" ")
	})())
}

export function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

export function ValidNullString(field) {
	return { Valid: field.String != "", String: field.String }
}

export function getCurrency(currency) {
	return MAP_CURRENCY[currency]
}

export function downloadCSV(csv, filename) {
	var csvFile
	var downloadLink

	// CSV file
	csvFile = new Blob([csv], { type: "text/csv" })

	// Download link
	downloadLink = document.createElement("a")

	// File name
	downloadLink.download = filename

	// Create a link to the file
	downloadLink.href = window.URL.createObjectURL(csvFile)

	// Hide download link
	downloadLink.style.display = "none"

	// Add the link to DOM
	document.body.appendChild(downloadLink)

	// Click download link
	downloadLink.click()
}

export function exportTableToCSV(filename) {
	var csv = []
	var rows = document.querySelectorAll("table tr")

	for (var i = 0; i < rows.length; i++) {
		var row = [],
			cols = rows[i].querySelectorAll("td, th")

		for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText)

		csv.push(row.join(","))
	}

	// Download CSV file
	downloadCSV(csv.join("\n"), filename)
}

export function equalArrays(array1, array2) {
	if (!Array.isArray(array1) || !Array.isArray(array2)) return false

	if (array2.length != array1.length) return false

	for (var i = 0, l = array2.length; i < l; i++) {
		if (array2[i] instanceof Array && array1[i] instanceof Array) {
			if (!this.equalArrays(array1[i], array2[i])) return false
		} else if (array2[i] != array1[i]) {
			return false
		}
	}
	return true
}

export const filters = {
	filters: {
		capitalize(value) {
			if (!value) return ""
			value = value.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		}
	}
}

export const getOwnerType = level => {
	if ([-1, 0].includes(level)) return "organizations"
	if ([1, 2].includes(level)) return "projects"
	if ([3].includes(level)) return "documents"
	return ""
}

export const getLevel = type => {
	const types = ["obbligatorie", "globali", "progetto", "procedura", "documento"]
	return types.findIndex(t => t === type) - 1
}

export const getSchoolNameFromOrganization = organization => {
	// le associazioni di organization devono essere incluse
	organization = organization || {}

	const customFieldValue =
		(organization.custom_field_values || []).find(
			({ custom_field: { name } }) => name === "denominazione scuola"
		) || {}

	return customFieldValue.value || (organization.name && organization.name.String)
}
